import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeoMeta } from "@/utils/seo";

function SeoRouteSync() {
  const location = useLocation();

  useEffect(() => {
    applySeoMeta({ pathname: location.pathname });
  }, [location.pathname]);

  return null;
}

export default SeoRouteSync;
